import type { VueConstructor } from 'vue';

export type BravadoSelectDropdownOption = {
  selectDropdownTitle: string;
  selectDropdownValue: string | number;
  selectDropdownHelperText?: string;
  selectDropdownImage?: BravadoSelectDropdownOptionImage;
};

export type BravadoSelectDropdownOptionImage = {
  shape: ImageShape;
  src?: string;
  component?: VueConstructor<Vue>;
  props: {
    [k: string]: any;
    alt: string;
  };
  placeholder?: PossibleImagePlaceholder;
};

export enum ImageShape {
  'circle' = 'circle',
  'rounded' = 'rounded',
}

export enum PossibleImagePlaceholder {
  'company' = 'company',
  'user' = 'user',
  'default' = 'default',
}
